import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "footer py-4 d-flex flex-lg-column",
  id: "kt_footer"
}
const _hoisted_2 = { class: "text-dark order-2 order-md-1" }
const _hoisted_3 = { class: "text-muted fw-bold me-1" }
const _hoisted_4 = {
  href: "{{footer_href}}",
  target: "_blank",
  class: "text-gray-800 text-hover-primary"
}
const _hoisted_5 = { class: "text-muted order-1 order-md-2" }
const _hoisted_6 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", {
      class: ["d-flex flex-column flex-md-row align-items-center justify-content-between", {
        'container-fluid': _ctx.footerWidthFluid,
        container: !_ctx.footerWidthFluid
      }]
    }, [
      _createVNode("div", _hoisted_2, [
        _createVNode("span", _hoisted_3, _toDisplayString(_ctx.currentYear) + " ©", 1),
        _createVNode("a", _hoisted_4, _toDisplayString(_ctx.footer_title), 1)
      ]),
      _createVNode("div", _hoisted_5, [
        (_ctx.buildNumber)
          ? (_openBlock(), _createBlock("span", _hoisted_6, "Build #" + _toDisplayString(_ctx.buildNumber), 1))
          : _createCommentVNode("", true)
      ])
    ], 2)
  ]))
}